module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/breeno-phone-2.0780ea31.png";